import { HttpClient } from "@angular/common/http";
import { Injectable, inject, DestroyRef, signal, computed } from "@angular/core";
import { tap } from "rxjs";
import { SelectOption, SelectOptionWithSelected } from "../../shared/interfaces/select-option";
import { LoadingService } from "../../shared/services/loading.service";

@Injectable({
    providedIn: 'root',
})
export class SecurityTypeService {
    private api: string = `investments/poolInvestments/securitytype/`;
    #httpClient = inject(HttpClient);
    #loadingService = inject(LoadingService);

    private _destroyRef = inject(DestroyRef);
    private _securityTypes = signal<SelectOption[]>([]);

    readonly securityTypes = this._securityTypes.asReadonly();
    readonly securityTypesWithSelect = computed(() => {
        return this._securityTypes().map((option) => {
            return {
                ...option,
                selected: false
            } as SelectOptionWithSelected;
        });
    });

    getSecurityTypes() {
        this.#loadingService.showLoadingIndicator();
        return this.#httpClient.get<SelectOption[]>(`${this.api}security-types`).pipe(
            tap(response => {
                this._securityTypes.set(response);
                this.#loadingService.hideLoadingIndicator();
            })
        );
    }
}